// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1ON3w","footer":"ReportModalFilter_footer__2qjQL"};